import React, { useState } from 'react'

const DispositivoForm = ({ onSubmit, initialValue }) => {

    const [dispositivo, setDispositivo] = useState({
        deviceId: initialValue.deviceId || '',
        hardwareVer: initialValue.hardwareVer || '',
        userDevice: initialValue.userDevice || '',
    })

    const handleChangeInput = (evt) => {
        setDispositivo({
            ...dispositivo,
            [evt.target.name]: Number(evt.target.value),
        })
    }

    const createInputElement = (elementName) => (
        <div className="label">
            <label>{elementName}</label>
            <input
                onChange={handleChangeInput}
                type="number"
                name={elementName}
                value={dispositivo[elementName]}
            />
        </div>
    )

    const handleSubmit = (evt) => {
        evt.preventDefault()

        onSubmit(dispositivo);

        setDispositivo({
            deviceId: '',
            hardwareVer: '',
            userDevice: '',
        })
    }


    return (
        <>
            <form onSubmit={handleSubmit}>
                {createInputElement('deviceId')}
                {createInputElement('hardwareVer')}
                {createInputElement('userDevice')}
                <button type="submit" disabled={!dispositivo.deviceId || !dispositivo.hardwareVer}>
                    Submit
                </button>
            </form>
            <p>Device Id:{dispositivo.deviceId}</p>
            <p>Hardware Ver:{dispositivo.hardwareVer}</p>
        </>
    )
}

export default DispositivoForm